import React, { useEffect, useState } from "react";
import "./index.less";
import useWindowDimensions, { decodeJWT } from "common/functions";
import { Collapse } from "antd";
import AnalysisItem from "../AnalysisItem";
import { emailToUsername } from "common/utils";
import { useSelector } from "react-redux";
import { rootReducerType } from "redux/combineReducers";
import { useGetMenuQuery } from "services/dashboardService";

const { Panel } = Collapse;

interface IProps {
  handleClickItem: (stationName: string) => void;
  shouldRefresh: boolean;
}
interface IStationItem {
  checked?: boolean;
  name?: string;
  key?: string;
}
const AnalysisStation: React.FC<IProps> = (props) => {
  const { width } = useWindowDimensions();
  const { handleClickItem, shouldRefresh } = props;

  const { isLoggedIn } = useSelector(
    (state: rootReducerType) => state.authenticationReducer
  );

  const params = { userName: emailToUsername(decodeJWT(isLoggedIn).email) };

  const [stationList, setStationList] = useState<any>();
  const { data: menuData } = useGetMenuQuery(params);

  useEffect(() => {
    if (menuData) {
      const dashboardMenu = menuData[0].Dashboard;
      let analysisStationList: any = [];

      for (let i = 0; i < dashboardMenu.length; i++) {
        if (dashboardMenu[i] !== "All") {
          analysisStationList.push({
            checked: false,
            key: dashboardMenu[i]["locationId.stationId"], // Adjust based on actual data structure
            name: dashboardMenu[i]["stationName"], // Adjust based on actual data structure
          });
        }
      }

      analysisStationList.unshift({
        checked: true,
        name: "All Stations",
        key: "all",
        value: "all",
        label: "All Stations",
      });
      setStationList([...analysisStationList]);
    }
  }, [menuData]); // Depend on menuData to re-run this effect

  const handleCheck = (name: string) => {
    let clickItem = stationList.find((i) => i.key === name);
    const clickIndex = stationList.findIndex((i) => i.key === name);
    if (clickItem?.checked) return;
    const _stationList: IStationItem[] = [...stationList].map(
      (i: IStationItem) => {
        return { ...i, checked: false };
      }
    );
    clickItem = { ...clickItem, checked: true };
    _stationList[clickIndex] = clickItem;
    setStationList([..._stationList]);
    handleClickItem(clickItem.key);
  };

  const DesktopStation = () => {
    return (
      <div className="desktopStation">
        {stationList &&
          stationList.map((i) => {
            return (
              <AnalysisItem
                rowKey={i.key}
                key={i.key}
                name={i.name}
                checked={i.checked}
                handleCheck={handleCheck}
              />
            );
          })}
      </div>
    );
  };
  const MobileStation = () => {
    return (
      <div className="mobileStation">
        <Collapse>
          <Panel header="Choose stations" key={1}>
            {stationList &&
              stationList.map((i) => {
                return (
                  <AnalysisItem
                    rowKey={i.key}
                    key={i.key}
                    name={i.name}
                    checked={i.checked}
                    handleCheck={handleCheck}
                  />
                );
              })}
          </Panel>
        </Collapse>
      </div>
    );
  };

  return (
    <div className="analysisStation">
      {width > 768 ? DesktopStation() : MobileStation()}
    </div>
  );
};

export default AnalysisStation;
